import { Checkbox } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import lockIcon from "../../assets/img/lock-icon.png";
import google from "../../assets/img/signin-google.png";
import Cookies from "js-cookie";
import { withRouter } from "react-router-dom";
import API_BASE from "../../config/api";

function Login() {
  const [errorMessage, setErrorMessage] = useState("");
  const [screenWidth, setScreenWidth] = useState("1920");

  // const clientId = 'YOUR_CLIENT_ID_HERE';

  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const mobileRegex = /^\d{10}$/;

  const [email, setEmail] = useState("");
  const [mobile_no, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showEmailOtpPrompt, setShowEmailOtpPrompt] = useState(false);
  const [otpEmail, setOtpEmail] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [emailOtpMessage, setEmailOtpMessage] = useState("");
  const [emailOtpError, setEmailOtpError] = useState("");
  const [isEmailOtpLoading, setIsEmailOtpLoading] = useState(false);
  const emailOtpFallbackRef = useRef(null);
  const shouldScrollEmailOtpRef = useRef(false);
  const history = useHistory();

  useEffect(() => {
    // To redirect user if not authenticated
    const isAuthenticated = Cookies.get("token");
    const user_account_type = Cookies.get("user_account_type");

    if (!isAuthenticated) {
      history.push("/auth/signin");
    } else if (user_account_type === "borrower") {
      history.push("/b-dashboard");
    } else if (user_account_type === "lender") {
      history.push("/dashboard");
    } else if (user_account_type === "admin") {
      history.push("/a-users");
    }
  }, [history]);

  useEffect(() => {
    const rememberMe = localStorage.getItem("rememberMe");
    if (rememberMe) {
      setRememberMe(rememberMe);
    }
    if (localStorage.getItem("user-info")) {
    }
  }, []);

  const loginIdentifier = email || mobile_no;
  const unauthorizedLoginMessage = "Unauthorized, check your login credentials";

  function redirectAfterLogin(userAccountType) {
    if (userAccountType === "lender") {
      history.push("/dashboard");
    } else if (userAccountType === "borrower") {
      history.push("/b-dashboard");
    } else if (userAccountType === "admin") {
      history.push("/a-users");
    }
  }

  function handleLoginSuccess(data) {
    if (rememberMe) {
      localStorage.setItem("rememberMe", rememberMe);
    } else {
      localStorage.removeItem("rememberMe");
    }

    Cookies.remove("expressauth");
    Cookies.set("token", data.token);
    Cookies.set("user_account_type", data.user.user_account_type);
    Cookies.set("singpass_sync", data.user.singpass_sync);
    Cookies.set("email", data.user.email);
    localStorage.setItem("user-info", JSON.stringify(data));
    redirectAfterLogin(data.user.user_account_type);
  }

  async function login(event) {
    event.preventDefault();
    setErrorMessage("");
    setShowEmailOtpPrompt(false);
    setEmailOtpSent(false);
    setEmailOtp("");
    setEmailOtpError("");
    setEmailOtpMessage("");

    const trimmedIdentifier = loginIdentifier.trim();
    let item = null;

    if (emailRegex.test(trimmedIdentifier)) {
      item = { email: trimmedIdentifier, password };
      setOtpEmail(trimmedIdentifier);
    } else if (mobileRegex.test(trimmedIdentifier)) {
      item = { mobile_no: trimmedIdentifier, password };
      setOtpEmail("");
    } else {
      setErrorMessage("Please enter a valid email address or mobile number.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      });
      const data = await response.json().catch(() => ({}));

      if (response.status === 200) {
        handleLoginSuccess(data);
        return;
      }

      if (response.status === 401 && data?.message === unauthorizedLoginMessage) {
        shouldScrollEmailOtpRef.current = true;
        setShowEmailOtpPrompt(true);
        setErrorMessage(data.message);
        return;
      }

      throw new Error(data?.message || "Unable to sign in. Please try again.");
    } catch (error) {
      console.log(error);
      setErrorMessage(error.message);
    }
  }

  async function sendEmailOtp(event) {
    event.preventDefault();
    const trimmedEmail = otpEmail.trim();

    if (!emailRegex.test(trimmedEmail)) {
      setEmailOtpError("Please enter the email address for your account.");
      return;
    }

    setIsEmailOtpLoading(true);
    setEmailOtpError("");
    setEmailOtpMessage("");

    try {
      const response = await fetch(`${API_BASE}/auth/login/email-otp/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email: trimmedEmail }),
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data?.message || "Unable to send email OTP.");
      }

      setEmailOtpSent(true);
      setEmailOtp("");
      setEmailOtpMessage(
        data?.message || "Email OTP has been sent. Please check your inbox."
      );
    } catch (error) {
      setEmailOtpError(error.message);
    } finally {
      setIsEmailOtpLoading(false);
    }
  }

  async function verifyEmailOtp(event) {
    event.preventDefault();
    const trimmedEmail = otpEmail.trim();
    const trimmedOtp = emailOtp.trim();

    if (!emailRegex.test(trimmedEmail)) {
      setEmailOtpError("Please enter the email address for your account.");
      return;
    }

    if (!/^\d{6}$/.test(trimmedOtp)) {
      setEmailOtpError("Please enter the 6 digit OTP from your email.");
      return;
    }

    setIsEmailOtpLoading(true);
    setEmailOtpError("");
    setEmailOtpMessage("");

    try {
      const response = await fetch(`${API_BASE}/auth/login/email-otp/verify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email: trimmedEmail, otp: trimmedOtp }),
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data?.message || "Unable to verify email OTP.");
      }

      handleLoginSuccess(data);
    } catch (error) {
      setEmailOtpError(error.message);
    } finally {
      setIsEmailOtpLoading(false);
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (
      !showEmailOtpPrompt ||
      Number(screenWidth) > 1200 ||
      !shouldScrollEmailOtpRef.current
    ) {
      return;
    }

    const scrollTimer = setTimeout(() => {
      emailOtpFallbackRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      shouldScrollEmailOtpRef.current = false;
    }, 100);

    return () => clearTimeout(scrollTimer);
  }, [showEmailOtpPrompt, screenWidth]);

  const renderEmailOtpFallback = (isMobile = false) => {
    if (!showEmailOtpPrompt) return null;

    const panelStyle = {
      width: "100%",
      marginTop: 14,
      padding: isMobile ? "14px" : "16px",
      border: "1px solid #d9e8f7",
      borderRadius: "12px",
      background: "#f8fbff",
      color: "#243b53",
      boxSizing: "border-box",
    };
    const inputStyle = isMobile
      ? {
          width: "100%",
          padding: "9px 12px",
          borderRadius: "10px",
          border: "1px solid #b8c7d9",
          outline: "none",
          boxSizing: "border-box",
        }
      : undefined;
    const buttonBaseStyle = {
      width: "100%",
      marginTop: 10,
      padding: isMobile ? "12px 16px" : "10px 18px",
      borderRadius: "10px",
      border: "0",
      background: "#0e5aa5",
      color: "#fff",
      fontWeight: 700,
      cursor: isEmailOtpLoading ? "not-allowed" : "pointer",
      opacity: isEmailOtpLoading ? 0.65 : 1,
    };

    return (
      <div style={panelStyle}>
        <p
          style={{
            margin: "0 0 10px",
            color: "#102a43",
            fontWeight: 700,
            lineHeight: 1.4,
          }}
        >
          Having trouble with your password?
        </p>
        <p style={{ margin: "0 0 12px", color: "#52606d", lineHeight: 1.5 }}>
          We can email you a 6 digit OTP and sign you in with that code instead.
        </p>
        <div className={isMobile ? "" : "input-field"} style={{ width: "100%" }}>
          <label htmlFor="email-login-otp-email" className="input-label">
            Email address
          </label>
          <input
            id="email-login-otp-email"
            type="email"
            className={isMobile ? "" : "input-control"}
            value={otpEmail}
            placeholder="example@gmail.com"
            autoComplete="email"
            onChange={(event) => setOtpEmail(event.target.value)}
            style={inputStyle}
          />
        </div>
        {emailOtpSent && (
          <div
            className={isMobile ? "" : "input-field"}
            style={{ width: "100%", marginTop: 10 }}
          >
            <label htmlFor="email-login-otp-code" className="input-label">
              6 digit OTP
            </label>
            <input
              id="email-login-otp-code"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
              className={isMobile ? "" : "input-control"}
              value={emailOtp}
              placeholder="Enter OTP"
              autoComplete="one-time-code"
              onChange={(event) =>
                setEmailOtp(event.target.value.replace(/\D/g, "").slice(0, 6))
              }
              style={inputStyle}
            />
          </div>
        )}
        {emailOtpMessage && (
          <p style={{ margin: "10px 0 0", color: "#1f7a4d", lineHeight: 1.4 }}>
            {emailOtpMessage}
          </p>
        )}
        {emailOtpError && (
          <p style={{ margin: "10px 0 0", color: "#d93025", lineHeight: 1.4 }}>
            {emailOtpError}
          </p>
        )}
        <button
          type="button"
          style={{...buttonBaseStyle, marginTop: 12}}
          disabled={isEmailOtpLoading}
          onClick={emailOtpSent ? verifyEmailOtp : sendEmailOtp}
        >
          {isEmailOtpLoading
            ? "Please wait..."
            : emailOtpSent
            ? "Verify OTP and Sign In"
            : "Send Email OTP"}
        </button>
        {emailOtpSent && (
          <button
            type="button"
            style={{
              ...buttonBaseStyle,
              marginTop: 8,
              background: "#ffffff",
              color: "#0e5aa5",
              border: "1px solid #b8c7d9",
              opacity: isEmailOtpLoading ? 0.65 : 1,
            }}
            disabled={isEmailOtpLoading}
            onClick={sendEmailOtp}
          >
            Resend OTP
          </button>
        )}
      </div>
    );
  };

  return (
    <>
      {screenWidth > 1200 ? (
        <div>
          <div className="auth-header">
            <h3 className="auth-header-title">
              Welcome Back
              <br />
              to SmartLend
            </h3>
          </div>
          <div className="auth-body">
            <form className="auth-form-validation">
              <div className="input-field">
                <label htmlFor="email" className="input-label">
                  Email Address
                </label>
                <input
                  // type="text"
                  value={email || mobile_no}
                  className="input-control"
                  placeholder="Email Address"
                  autoComplete="off"
                  onChange={(event) =>
                    setEmail(event.target.value) ||
                    setMobileNo(event.target.value)
                  }
                  required
                />
              </div>
              <div className="input-field">
                <label htmlFor="password" className="input-label">
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  className="input-control"
                  name="password"
                  placeholder="Password"
                  // iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                  autoComplete="off"
                  onChange={(event) => setPassword(event.target.value)}
                  required
                />
              </div>
              <div className="flex-end">
                <Checkbox
                  className="checkbox-login"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                >
                  Remember me
                </Checkbox>
                <Link to={"/auth/forgot-password"} className="link-end">
                  <img src={lockIcon} alt="" width={15} height={14} /> Forgot
                  password
                </Link>
              </div>

              <div className="btn-position">
                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}
                <button
                  type="submit"
                  className="btn-submit"
                  onClick={login}
                  style={{ width: "100%" }}
                >
                  Sign In
                </button>
              </div>
              {renderEmailOtpFallback(false)}
              {/* { loggedIn ( */}
              <div className="btn-position">
                <div
                  className="btn-submit-default"
                  style={{ border: "1px solid grey" }}
                >
                  <a href="https://www.smart-lend.com/api/auth/login/google">
                    <img
                      src={google}
                      alt="Google Sign-in button"
                      width={518}
                      height={68}
                    />
                  </a>
                </div>
              </div>
              {/* singpass login button */}
              {/* <div className="btn-position">
       <button className="btn-submit-singpass">
         <img src={singpass} alt="" onClick={""} />
       </button>
     </div> */}
            </form>
            <p className="text-center">
              Don't have an account?{" "}
              <Link to={"/auth/signup"} className="link-text-center-signup">
                Sign up
              </Link>
            </p>
          </div>
        </div>
      ) : (
        <div>
          <div
            style={{
              background:
                "transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box",

              width: "95%",
              marginLeft: "10px",
            }}
          >
            <div style={{ width: "100%" }}>
              <h3 className="auth-header-title" style={{ fontSize: "45px" }}>
                Welcome Back to SmartLend
              </h3>
            </div>
            <div className="auth-body" style={{ width: "100%" }}>
              <form className="auth-form-validation" style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <label htmlFor="email">Email / Mobile Number</label>
                  <input
                    // type="text"
                    value={email || mobile_no}
                    placeholder="Email / Mobile Number"
                    autoComplete="off"
                    onChange={(event) =>
                      setEmail(event.target.value) ||
                      setMobileNo(event.target.value)
                    }
                    required
                    style={{
                      width: "100%",
                      padding: "6px 12px",
                      borderRadius: "10px",
                      border: "1px solid grey",
                      outline: "none",
                    }}
                  />
                </div>
                <div style={{ margin: "10px 0px 20px 0px" }}>
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    value={password}
                    name="password"
                    placeholder="Password"
                    // iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    autoComplete="off"
                    onChange={(event) => setPassword(event.target.value)}
                    required
                    style={{
                      width: "100%",
                      padding: "6px 12px",
                      borderRadius: "10px",
                      border: "1px solid grey",
                      outline: "none",
                    }}
                  />
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Checkbox
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                  >
                    Remember me
                  </Checkbox>
                  <Link to={"/auth/forgot-password"}>
                    <img src={lockIcon} alt="" width={15} height={14} /> Forgot
                    password
                  </Link>
                </div>

                <div className="btn-position" style={{ width: "100%" }}>
                  {errorMessage && (
                    <div className="error-message">{errorMessage}</div>
                  )}
                  <button
                    type="submit"
                    style={{
                      background: "#0e5aa5",
                      color: "white",
                      width: "100%",
                      fontSize: 15,
                      padding: "14px 20px",
                      borderRadius: "10px",
                    }}
                    onClick={login}
                  >
                    Sign In
                  </button>
                </div>
                <div ref={emailOtpFallbackRef}>
                  {renderEmailOtpFallback(true)}
                </div>
                {/* { loggedIn ( */}
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      width: "100%",
                      border: "1px solid grey",
                      borderRadius: "10px",
                    }}
                  >
                    <a
                      href="https://www.smart-lend.com/api/auth/login/google"
                      style={{
                        width: "100%",
                      }}
                    >
                      <img
                        src={google}
                        alt="Google Sign-in button"
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          maxHeight: "55px",
                        }}
                      />
                    </a>
                  </div>
                </div>
                {/* singpass login button */}
                {/* <div className="btn-position">
       <button className="btn-submit-singpass">
         <img src={singpass} alt="" onClick={""} />
       </button>
     </div> */}
              </form>
              <p className="text-center">
                Don't have an account?{" "}
                <Link to={"/auth/signup"} className="link-text-center-signup">
                  Sign up
                </Link>
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
// };

export default withRouter(Login);
